// removed by extract-text-webpack-plugin
module.exports = {"EditCreateDivision":"EditCreateDivision--2NnuA"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Division/EditCreateDivision.scss
// module id = 945
// module chunks = 1